/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

Liferay.Workflow = {
	ACTION_PUBLISH: 1,

	ACTION_SAVE_DRAFT: 2,

	STATUS_ANY: -1,

	STATUS_APPROVED: 0,

	STATUS_DENIED: 4,

	STATUS_DRAFT: 2,

	STATUS_EXPIRED: 3,

	STATUS_PENDING: 1,
};
